module.exports = __webpack_public_path__ + "static/media/google-docs.fcdc4f05.svg";